import { render, staticRenderFns } from "./SingleFileUploader.vue?vue&type=template&id=a41af792&scoped=true&"
import script from "./SingleFileUploader.vue?vue&type=script&lang=js&"
export * from "./SingleFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./SingleFileUploader.vue?vue&type=style&index=0&id=a41af792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41af792",
  null
  
)

export default component.exports
import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'directives', {Ripple});
